import { useLocation, useRouteMatch } from 'react-router-dom'
import type { EFinancingOfferRoute } from '@/types'
import { COMMENTS_MESSAGES, ROUTES_WITH_SHOW_WIDGET } from './constants'

export const useIsShowWidget = () => {
  const match = useRouteMatch(ROUTES_WITH_SHOW_WIDGET)

  return match?.isExact === true
}

export const useGetContextForCommentField = () => {
  const { pathname } = useLocation()
  const match = useRouteMatch(pathname)

  if (match?.isExact === true && match?.path) return COMMENTS_MESSAGES[match?.path as EFinancingOfferRoute]
}
